"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodErrorResponse = void 0;
var MethodErrorResponse;
(function (MethodErrorResponse) {
    MethodErrorResponse["FALLBACK"] = "fallback";
    MethodErrorResponse["GET_USER_DETAILS_FROM_ACCESS_METHOD"] = "getUserDetailsFromAccessMethod";
    MethodErrorResponse["CHECK_ACCESS_STATUS"] = "checkAccessStatus";
    MethodErrorResponse["MISSING_REQUIRED_PARAMS"] = "missingRequiredParams";
})(MethodErrorResponse = exports.MethodErrorResponse || (exports.MethodErrorResponse = {}));
